import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import MaterialInput from '@material-ui/core/Input';
import _ from 'lodash';
const BuyerDetail = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [buyer, , buyerLoading] = useGet(
    `/buyers/${id}?filter[include][0][relation]=district`,
    true
  );
  const [districts, , districtsLoading] = useGet('/districts', true);

  const [vegetables, , vegetablesLoading] = useGet('/vegetables', true);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedVegetables, setSelectedVegetables] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [cnic, setCnic] = useState('');
  const [postBuyer, postedData, postingError, dataPosting] = usePatch(
    `/buyers/${id}`
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();
  const handleFormSubmit = (event, errors, values) => {
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }
    if (!selectedDistrict || !selectedVegetables) {
      return toastr.warning('Please fix errors in the form');
    }
    if (selectedVegetables.length === 0) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = _.omit(
      {
        ...values,

        districtId: selectedDistrict.value,

        vegetablePreference: selectedVegetables.map((x) => x.value),
      },
      'phone'
    );

    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postBuyer({ ...obj, profilePicture: _urls[0] });
      });
    } else {
      postBuyer(obj);
    }
  };
  useEffect(() => {
    if (buyer) {
      setSelectedDistrict({
        value: buyer.district.id,
        label: buyer.district.name,
      });

      setSelectedVegetables(
        buyer.vegetables.map((x) => ({ value: x.id, label: x.name }))
      );
      setCnic(buyer.CNIC);
    }
  }, [buyer]);
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Buyer has been updated successfully');
      history.push('/users/buyers');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Buyer</h4>
                <Card>
                  <CardBody>
                    {buyerLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor='name'>Name</Label>
                              <AvField
                                name='name'
                                placeholder='Name'
                                type='text'
                                errorMessage='Enter Name'
                                className='form-control'
                                validate={{ required: { value: true } }}
                                id='name'
                                value={buyer?.name}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <Label>CNIC</Label>
                            <InputMask
                              mask='99999-9999999-9'
                              value={cnic}
                              className='form-control input-color'
                              onChange={({ target: { value } }) =>
                                setCnic(value)
                              }
                            >
                              {(inputProps) => (
                                <MaterialInput
                                  {...inputProps}
                                  type='tel'
                                  disableUnderline
                                />
                              )}
                            </InputMask>
                          </Col>
                        </Row>
                        <Row className='mb-3'>
                          <Col md={1}>
                            <img
                              src={buyer?.profilePicture}
                              className='rounded-circle avatar-sm card-img'
                            />
                          </Col>
                          <Col md={11}>
                            <FormGroup>
                              <div
                                className='custom-file'
                                style={{ zIndex: 0 }}
                              >
                                <CustomInput
                                  type='file'
                                  className='custom-file-input'
                                  id='image'
                                  accept='image/*'
                                  onChange={(e) => {
                                    setSelectedImage(e.target.files[0]);
                                  }}
                                />
                                <Label
                                  className='custom-file-label'
                                  htmlFor='image'
                                >
                                  {selectedImage
                                    ? selectedImage.name
                                    : 'Change Profile Picture'}
                                </Label>
                              </div>
                              {selectedImage && (
                                <span className='d-block font-size-20 text-danger text-right'>
                                  <i
                                    onClick={() => setSelectedImage(null)}
                                    style={{ cursor: 'pointer' }}
                                    className='ri-close-line'
                                  ></i>
                                </span>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label htmlFor='phone'>Phone</Label>
                              <AvField
                                disabled
                                name='phone'
                                placeholder='Phone (923xxxxxxxxxx)'
                                type='text'
                                errorMessage='Enter Phone in (923xxxxxxxxxx)'
                                className='form-control'
                                validate={{
                                  required: { value: true },
                                  pattern: { value: '^923' },
                                  minLength: { value: 12 },
                                  maxLength: { value: 12 },
                                }}
                                id='name'
                                value={buyer?.phone}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>District</Label>
                              <Select
                                isLoading={districtsLoading}
                                value={selectedDistrict}
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedDistrict(e)}
                                options={districts?.map((x) => ({
                                  value: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col md={12}>
                            <FormGroup>
                              <Label>Vegetable Preferences</Label>
                              <Select
                                isLoading={vegetablesLoading}
                                value={selectedVegetables}
                                isMulti
                                closeMenuOnSelect={false}
                                onChange={(e) => setSelectedVegetables(e)}
                                options={vegetables?.map((x) => ({
                                  value: x.id,
                                  label: x.name,
                                }))}
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <FormGroup>
                          <Label htmlFor='phone'>Address</Label>
                          <AvField
                            name='address'
                            placeholder='Address'
                            type='text'
                            errorMessage='Enter Address'
                            className='form-control'
                            validate={{
                              required: { value: true },
                            }}
                            id='name'
                            value={buyer?.address}
                          />
                        </FormGroup>
                        {/* <div className='border mb-3 mt-2'></div>
                        <FormGroup>
                          <Label htmlFor='password'>Change Password</Label>
                          <AvField
                            name='password'
                            placeholder='Password'
                            type='text'
                            errorMessage='Minimun length required is 5'
                            className='form-control'
                            validate={{
                              minLength: { value: 5 },
                            }}
                            id='password'
                          />
                        </FormGroup> */}
                      </>
                    )}
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Update Buyer'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default BuyerDetail;
